import flightPackCode from "./flightPackCode"
import transportPackCode from "./transportPackCode"

export const transportPacks = [
    ...flightPackCode,
    ...transportPackCode
]


export const nonTransportPacks = [
    "PFP",
    "PF",
    "PFPCS",
    "PFCS",
    "HS",
] 